const EventSearchClear = () => {
    const searchInputs = document.querySelectorAll('.tribe-events-c-search__input');

    searchInputs.forEach(input => {
        const clearButton = document.createElement('button');
        clearButton.className = 'tribe-events-c-search__clear-button';
        clearButton.textContent = '';

        input.parentNode.appendChild(clearButton);

        input.addEventListener('input', function () {
            clearButton.style.display = this.value ? 'block' : 'none';
        });

        clearButton.addEventListener('click', function () {
            event.preventDefault();
            input.value = '';
            clearButton.style.display = 'none';
        });
    });
};

export default EventSearchClear;
